import { type FormEvent, useState } from 'react'
import type { VisualGroup } from '../../api/visuals'
import { Button, FormField, Modal, ModalActions } from '../../components/ui'

type VisualGroupDialogProps = {
  group: VisualGroup
  onClose: () => void
  onSave: (input: {
    id: string
    name: string
    description: string | null
  }) => Promise<void>
}

export const VisualGroupDialog = (props: VisualGroupDialogProps) => {
  const [name, setName] = useState(props.group.name)
  const [description, setDescription] = useState(props.group.description ?? '')
  const [saving, setSaving] = useState(false)

  const save = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault()
    setSaving(true)
    await props.onSave({
      id: props.group.id,
      name,
      description: description.trim() || null
    })
    setSaving(false)
  }

  return (
    <Modal
      ariaLabelledBy="visual-group-title"
      mobilePresentation="sheet"
      onClose={props.onClose}
      onSubmit={(event) => void save(event)}
      title={<h2 id="visual-group-title">{props.group.id ? 'Edit visual group' : 'Create visual group'}</h2>}
    >
      <FormField label="Name">
        <input className="form-input" onChange={(event) => setName(event.target.value)} value={name} />
      </FormField>
      <FormField label="Description">
        <textarea className="form-input" onChange={(event) => setDescription(event.target.value)} value={description} />
      </FormField>
      {props.group.id && (
        <p className="muted">
          Used by {props.group.channel_count} channel(s), contains {props.group.asset_count} asset(s).
        </p>
      )}
      <ModalActions>
        <Button onClick={props.onClose} variant="secondary">Cancel</Button>
        <Button disabled={saving} type="submit" variant="primary">
          {saving ? 'Saving...' : 'Save'}
        </Button>
      </ModalActions>
    </Modal>
  )
}
